// @flow

import React from 'react';
import Translate from 'client/components/translate';
import FunnelStep from 'client/components/funnelStep';
import InputZip from 'client/components/form/inputZip';
import '../styles/onboarding.scss';

type Props = {
  enableDentalVisionEmailCollection: boolean,
  submitHandler: Function,
  zipcode: string,
  zipError: Object,
};

const LocationPage = ({
  submitHandler = () => {},
  zipcode = '',
  zipError = null,
  enableDentalVisionEmailCollection = false,
}: Props) => (
  <FunnelStep index={0} descriptKey="vision.nav.location">
    <div id="locationPage">
      <div className="center-col-small pad-top-3 text-center pad-x">
        <div className="header">
          <Translate path="vision.location" />
        </div>

        <div className="flex-row center pad-top-2">
          <InputZip
            label={{ path: 'common.label.zipCode' }}
            initialValue={zipcode || ''}
            error={zipError}
            submitHandler={submitHandler}
            hasEmailInput={enableDentalVisionEmailCollection} />
        </div>
      </div>
    </div>
  </FunnelStep>
);

export default LocationPage;
